import { authXConfig } from 'router/authx-config';

export const DELIBERATE_CLOSE = 3001;

export const getWebsocketUrlForPark = (parkName, token) => {
    const code = localStorage.getItem('auth_code');
    const URL = `${authXConfig.API.WebSocketAPI.baseURL}${parkName}?token=${token}&code=${code}`;

    return URL;
};
